import type { InterviewConsentPayload } from '@Application/Beneficiaries/Interviews/Actions/interviewConsentFetched';

/**
 * Immutable View: `readonly` properties, frozen at the end of the constructor.
 * `interviewId` is not on the payload: it is carried by every action that produces this View
 * and passed in here, the same way `RecordingView.interviewId` is. `grantedAt`/`recordedAt`/
 * `withdrawnAt` are instants (ISO 8601 with time), not civil dates: straight `new Date(iso)`
 * conversion is correct here, unlike `InterviewView.conductedOn`, which is a `PlainDate`.
 * `recordedAt` is the instant the server received `grantedAt` — the reading that makes a
 * client-declared consent instant auditable.
 */
class InterviewConsentView {
	readonly id: number;
	readonly interviewId: number;
	readonly grantedAt: Date;
	readonly recordedAt: Date;
	readonly grantedByName: string;
	readonly withdrawnAt: Date | null;
	readonly withdrawnByName: string | null;

	constructor(payload: InterviewConsentPayload, interviewId: number) {
		this.id = payload.id;
		this.interviewId = interviewId;
		this.grantedAt = new Date(payload.grantedAt);
		this.recordedAt = new Date(payload.recordedAt);
		this.grantedByName = payload.grantedByName;
		this.withdrawnAt = payload.withdrawnAt !== null ? new Date(payload.withdrawnAt) : null;
		this.withdrawnByName = payload.withdrawnByName;

		Object.freeze(this);
	}

	/** The screen state is read here, never recomputed in JSX: no status enum exists for this reason. */
	get isWithdrawn(): boolean {
		return this.withdrawnAt !== null;
	}
}

export default InterviewConsentView;
